import React from 'react';
import { PortableText } from '@portabletext/react';

import AccordionList from 'components/ui/AccordionList';
import Container from 'components/ui/Container';
import Typography from 'components/ui/Typography';
import { AnswerGroup } from 'types/FAQ';
import classes from './FAQ.module.css';

export type FAQProps = {
  groups: AnswerGroup[];
};

const FAQAnswer = ({ answer }: { answer: AnswerGroup['questions'][number]['answer'] }) => {
  if (typeof answer === 'string') {
    return (
      <Typography className={classes.answerParagraph} component="p">
        {answer}
      </Typography>
    );
  }

  return (
    <PortableText
      components={{
        block: {
          normal: ({ children }) => (
            <Typography className={classes.answerParagraph} component="p">
              {children}
            </Typography>
          ),
        },
        marks: {
          em: ({ children }) => <em style={{ fontStyle: 'italic' }}>{children}</em>,
          link: ({ children, value }) => (
            <a className={classes.link} href={value?.href}>
              {children}
            </a>
          ),
          strong: ({ children }) => <Typography variant="b">{children}</Typography>,
        },
      }}
      value={answer}
    />
  );
};

const FAQ: React.FC<FAQProps> = props => {
  return (
    <Container padding="tight">
      <div className={classes.groups}>
        {props.groups.map(({ groupTitle: title, questions }) => {
          return (
            <div key={title}>
              <Typography className={classes.title} variant="h1" component="h2">
                {title}
              </Typography>
              <AccordionList
                items={questions.map((v, i) => ({
                  content: <FAQAnswer answer={v.answer} />,
                  key: i,
                  title: v.question,
                }))}
              />
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default FAQ;
